import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en } from './locales/en';
import { sv } from './locales/sv';

export const resources = {
    en: { translation: en },
    sv: { translation: sv },
} as const;

function detectInitialLng(): 'en' | 'sv' {
    const stored = (localStorage.getItem('lang') || '').toLowerCase();
    if (stored === 'en' || stored === 'sv') return stored as 'en' | 'sv';
    const langs = (navigator.languages?.length ? navigator.languages : [navigator.language]).map(l => (l || '').toLowerCase());
    return langs[0]?.startsWith('sv') ? 'sv' : 'en';
}

i18n.use(initReactI18next).init({
    resources,
    lng: detectInitialLng(),
    fallbackLng: 'en',
    supportedLngs: ['en', 'sv'],
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    returnNull: false,
});

export default i18n;
